import * as yup from 'yup';
import { fieldValidationMessages } from 'app/constants';

export const validationSchema = yup.object().shape({
  token: yup
    .string()
    .required(fieldValidationMessages.REQUIRED)
    .length(6, fieldValidationMessages.LENGTH(6)),
});
